import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDnMrIVkx-6V0Brm4pxezeOVcTOELsTmdQ",
  authDomain: "bbpix-1.firebaseapp.com",
  projectId: "bbpix-1",
  storageBucket: "bbpix-1.firebasestorage.app",
  messagingSenderId: "593797963197",
  appId: "1:593797963197:web:b37170e3a05404a65c06d4",
  measurementId: "G-Z7HFL9XT00",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
const analytics = getAnalytics(app);

// Initialize Auth with persistence
const auth = getAuth(app);

// Check localStorage availability
const checkLocalStorageAvailability = () => {
  try {
    const testKey = "__firebase_test__";
    localStorage.setItem(testKey, "test");
    localStorage.removeItem(testKey);
    console.log("✅ localStorage is available for auth persistence");
    
    // Additional mobile-specific checks
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isStandalone = window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
    
    if (isMobile) {
      console.log("📱 Mobile device detected");
      if (isIOS) {
        console.log("🍎 iOS device detected");
        if (!isStandalone) {
          console.warn("⚠️ NOT running as standalone PWA - Auth may be less reliable on iOS Safari");
          console.warn("💡 TIP: For best experience on iOS, use 'Add to Home Screen'");
        } else {
          console.log("✅ Running as standalone PWA - Auth should persist");
        }
      }
    }
    
    return true;
  } catch (e) {
    console.error("❌ localStorage is NOT available:", e);
    console.warn("⚠️ Auth persistence may not work. Possible causes:");
    console.warn("   - Private/Incognito browsing mode");
    console.warn("   - Browser storage disabled");
    console.warn("   - iOS Safari privacy restrictions");
    return false;
  }
};

// Check storage and set persistence
const storageAvailable = checkLocalStorageAvailability();

if (storageAvailable) {
  // Set persistence to LOCAL (survives browser/tab close)
  // IMPORTANT: This must be set BEFORE any auth operations
  setPersistence(auth, browserLocalPersistence)
    .then(() => {
      console.log("✅ Firebase Auth persistence set to LOCAL");
      
      // Verify persistence was set correctly
      if (auth._delegate?._config?.persistence) {
        console.log("✅ Auth persistence verified:", auth._delegate._config.persistence);
      }
    })
    .catch((error) => {
      console.error("❌ Failed to set auth persistence:", error);
      console.warn("⚠️ Auth may not persist across sessions");
      console.warn("💡 On mobile, ensure:");
      console.warn("   - Not in private/incognito mode");
      console.warn("   - Browser storage is enabled");
      console.warn("   - For iOS: Use 'Add to Home Screen' for best results");
    });
} else {
  console.warn("⚠️ Skipping auth persistence setup due to storage unavailability");
  console.warn("💡 This will cause users to need to log in every time");
}

// Initialize Firestore with offline persistence
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

// Initialize Functions
const functions = getFunctions(app);

// Initialize Storage
const storage = getStorage(app);

export { app, analytics, auth, db, functions, storage };

